<script setup lang="ts">
import type { ComponentPromoCrossSellingProps } from "./ComponentPromoCrossSelling.props"
const props = defineProps<ComponentPromoCrossSellingProps>()
</script>

<template>
  <ProductBlocksBrandBlockSmall
    v-bind="banner"
    theme="green-10"
    :isAlwaysVertical="true"
    class="mb-4"
  />
</template>
